import clsx from 'clsx'
import { FunctionComponent } from 'react'

interface Props {
  className?: string
}

const LoginCheckIcon: FunctionComponent<Props> = ({ className = '' }) => (
  <svg
    viewBox="0 0 611 612"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <switch>
      <foreignObject
        width="1"
        height="1"
        requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
      ></foreignObject>
      <g>
        <path
          className="fill-[#7B8EC7]"
          d="m305.5 580.8c-73.3 0-142.2-28.5-194-80.3s-80.3-120.7-80.3-194 28.5-142.2 80.3-194 120.7-80.3 194-80.3 142.2 28.5 194 80.3 80.3 120.7 80.3 194-28.5 142.2-80.3 194-120.7 80.3-194 80.3z"
        />
        <path
          className="fill-[#171441]"
          d="m305.5 58c137.2 0 248.5 111.3 248.5 248.5s-111.3 248.5-248.5 248.5-248.5-111.3-248.5-248.5 111.3-248.5 248.5-248.5m0-51.6c-40.5 0-79.8 7.9-116.8 23.6-35.7 15.1-67.8 36.8-95.4 64.3-27.5 27.5-49.2 59.6-64.3 95.4-15.7 37-23.6 76.3-23.6 116.8s7.9 79.8 23.6 116.8c15.1 35.7 36.8 67.8 64.3 95.4 27.5 27.5 59.6 49.2 95.4 64.3 37 15.7 76.3 23.6 116.8 23.6s79.8-7.9 116.8-23.6c35.7-15.1 67.8-36.8 95.4-64.3 27.5-27.5 49.2-59.6 64.3-95.4 15.7-37 23.6-76.3 23.6-116.8s-7.9-79.8-23.6-116.8c-15.1-35.7-36.8-67.8-64.3-95.4-27.5-27.5-59.6-49.2-95.4-64.3-37-15.7-76.3-23.6-116.8-23.6z"
        />

        <path
          className="fill-[#FFFFFF]"
          d="m280.6 320.3c2-2.8 2.9-4.5 4.2-5.8 30.1-30.1 60.1-60.3 90.3-90.3 18.4-18.3 48.4-11 55.7 13.3 3.9 13 0.5 24.3-9 33.8-22.2 22.3-44.4 44.5-66.6 66.7l-49.4 49.4c-15.6 15.6-35 15.7-50.6 0.1-22.2-22.1-44.2-44.2-66.3-66.3-9.5-9.6-12.6-21.1-8.8-33.9 3.7-12.2 12.3-20.1 24.8-22.7 12.1-2.5 22.6 1.1 31.3 9.9 13.2 13.3 26.6 26.6 39.8 39.9 1.5 1.3 2.4 2.9 4.6 5.9z"
        />
      </g>
    </switch>
  </svg>
)

export default LoginCheckIcon
